import { render, staticRenderFns } from "./areaComponent.vue?vue&type=template&id=457053a9&scoped=true&"
import script from "./areaComponent.vue?vue&type=script&lang=js&"
export * from "./areaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457053a9",
  null
  
)

export default component.exports